var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIncidentFirstLocationPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    height: "40px",
    width: "40px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{fill:#175B9E;}\n\t\t.st1{fill:#FFFFFF;}\n\t\t.st2{enable-background:new    ;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    transform: "translate(321 162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2590"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-309.3-161c-4.8,0.2-8.6,4.2-8.5,9.1c0,0.5,0.1,0.9,0.2,1.3c0,0,0,0.1,0.1,0.3c0.1,0.6,0.3,1.2,0.6,1.7 c0.9,2.1,2.9,5.6,7.5,9.4c0.3,0.2,0.7,0.2,1,0c4.6-3.8,6.6-7.3,7.5-9.4c0.3-0.6,0.5-1.1,0.6-1.7c0-0.2,0.1-0.3,0.1-0.3 c0.1-0.5,0.2-1.1,0.2-1.7c0-4.8-3.9-8.8-8.8-8.8C-309.1-161-309.2-161-309.3-161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-309-138.5c-0.3,0-0.6-0.1-0.8-0.3c-4.6-3.8-6.7-7.3-7.6-9.6c-0.3-0.6-0.5-1.2-0.6-1.8 c-0.1-0.2-0.1-0.3-0.1-0.3c-0.1-0.4-0.1-0.9-0.2-1.4c-0.2-5.1,3.8-9.4,8.9-9.6l0,0c2.6-0.1,5.1,0.9,6.9,2.7 c1.8,1.8,2.7,4.1,2.7,6.6c0,0.6-0.1,1.2-0.2,1.8c0,0,0,0,0,0s0,0.1-0.1,0.3c-0.1,0.6-0.3,1.2-0.6,1.8c-0.9,2.3-3,5.8-7.6,9.5 C-308.4-138.6-308.7-138.5-309-138.5z M-309.3-160.5c-2.2,0.1-4.3,1-5.8,2.6c-1.5,1.6-2.3,3.7-2.2,5.9c0,0.4,0.1,0.8,0.1,1.3 c0,0,0,0.1,0.1,0.2c0.1,0.6,0.3,1.1,0.6,1.7c0.9,2.2,2.9,5.5,7.3,9.2c0.1,0.1,0.2,0.1,0.3,0c4.4-3.7,6.4-7,7.3-9.2 c0.3-0.5,0.4-1.1,0.6-1.7c0-0.2,0.1-0.3,0.1-0.3c0.1-0.5,0.1-1,0.1-1.6c0-2.2-0.9-4.3-2.4-5.9C-304.8-159.7-307-160.6-309.3-160.5 L-309.3-160.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-310.8-148.8h1.8v-5.6h-1.4v-0.6c0.7-0.1,1.2-0.3,1.6-0.6h0.8v6.8h1.6v0.8h-4.3V-148.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncidentFirstLocationPoint);
export default __webpack_public_path__ + "static/media/icon_incident_first_location_point.800feefb04b77cacda25ed2976091d63.svg";
export { ForwardRef as ReactComponent };